import { surveyFormsService } from "../../../../../Api/Services/SurveyFormsService";
import { IFormWithQuestionsResponse } from "../../../../../Types/SurveyFormsTypes";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";

// Thunk
export const fetchSurveyFormWithQuestions = createServiceAsyncThunk<
  IFormWithQuestionsResponse,
  number // form_id
>(
  ACTION_NAMES.SURVEY_FORM_WITH_QUESTIONS,
  (form_id) => surveyFormsService.getFormWithQuestions(form_id),
  ERROR_MESSAGES.SURVEY_FORM_WITH_QUESTIONS_FAILURE
);

// Slice
const surveyFormWithQuestionsSlice = createGenericSlice<
  IFormWithQuestionsResponse,
  number
>(SLICE_NAMES.SURVEY_FORM_WITH_QUESTIONS, fetchSurveyFormWithQuestions);

export const {
  clearError: clearSurveyFormWithQuestionsError,
  clearSuccessMessage: clearSurveyFormWithQuestionsSuccess,
} = surveyFormWithQuestionsSlice.actions;

export default surveyFormWithQuestionsSlice.reducer;
